import React from 'react';
import { getViewportInfo } from '../../../../../../../utils';
import {
  ClearAll,
  StyledFilterContainer,
} from '../../../../CategoryListingPage/molecules/CategoryModuleFilter/styles/CategoryModuleFilter.style';
import {
  getAppliedFiltersCount,
  renderAppliedFilters,
} from '../../../../CategoryListingPage/molecules/CategoryModuleFilter/views/CategoryModuleFilter';
import { getLabelFromCopyOrFromTranslation } from '../../../../../../../utils/labels/labelUtilty';
import filterChipsLabels from '../../../../../../common/atoms/FilterChips/views/FilterChips.labels';
import useQuickFilters from '../../../hooks/useQuickFilters';

const FilterPillsModule = ({
  appliedFilters = {},
  filterMaps,
  isLoadingMore,
  updateBopisFormValue,
  isFacetedNavigationEnabled,
  pathName,
  seoFacetedNavigationConfig,
  cleanUrlObj,
  formDetails,
  setPriceFilterFlagActn,
  setUpdatedUrlActn,
}) => {
  const isDesktop = getViewportInfo()?.isDesktop;
  const lblClear = getLabelFromCopyOrFromTranslation(
    'PLP.PLP_sort_filter.lbl_clear',
    filterChipsLabels
  );

  const [, , removeAllFilters] = useQuickFilters({
    appliedFilters,
    formDetails,
    isFacetedNavigationEnabled,
    seoFacetedNavigationConfig,
    setUpdatedUrlActn,
    pathName,
    cleanUrlObj,
    setPriceFilterFlagActn,
    updateBopisFormValue,
  });
  return (
    getAppliedFiltersCount(appliedFilters) > 0 &&
    isDesktop && (
      <StyledFilterContainer>
        {renderAppliedFilters({
          appliedFilters,
          filterMaps,
          isLoadingMore,
          updateBopisFormValue,
          isFacetedNavigationEnabled,
          pathName,
          seoFacetedNavigationConfig,
          cleanUrlObj,
          formDetails,
          setPriceFilterFlagActn,
          setUpdatedUrlActn,
        })}
        <ClearAll onClick={removeAllFilters}>{lblClear}</ClearAll>
      </StyledFilterContainer>
    )
  );
};

export default FilterPillsModule;
FilterPillsModule.displayName = 'FilterPillModule';
